// extracted by mini-css-extract-plugin
module.exports = {"link":"TablePage_link__3SyKA","ctnList":"TablePage_ctnList__28kGL","title":"TablePage_title__2xOqJ"};